import React, { Component } from "react";
import logo from "./../../assets/logo.png";
// import NavMenu from "./NavMenu";
import { SELECTED_SIDE_BAR_ITEM_KEY } from "../SidebarContent/SidebarContent";
import { AlignRight } from "react-feather";
import { getUser } from "../../utils/localStorage";

const user = getUser()

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      selectedItemPath: null,
      showNavbar:  user && user?.role && user?.role?.includes(16)
    };
  }
  handleItemClick = item => {
    this.setState({ selectedItemPath: item.path });
    localStorage.setItem("SELECTED_SIDE_BAR_ITEM", item.path);
    if (item.id === "logout") {
      localStorage.clear();
    }
    this.props.history.push(`${item.path}`);
  };
  render() {
    return (
      <div className="top-nav-bar navbar fixed-top flex-md-nowrap" style={{textAlign:"center",zIndex:"3"}}>
        <div style={{float:"left",width:"135px"}}>
          <img
            alt="deasra-icon"
            src={logo}
            className="h30 cursor-pointer"
            onClick={() => {
              if(user.role[0] === 12){
                localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/home/newandengagedusers");
                this.props.history.push('/home/newandengagedusers')
              } else {
                localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/home");

              /**
               * function to move between routes.
               */
              this.props.history.push("/home");
              }
              
            }}
          />

          {/* <NavMenu
          onItemClick={route => this.handleItemClick(route)}
          {...this.props}
        /> */}
        </div>        
        
        <div style={{float:"left",textAlign:"center",marginLeft:"-100px"}}>
          <span><b>{this.props.Pagetitle}</b></span>
        </div>
        <div style={{float:"left",width:"25px"}}>
          {
            this?.props?.userDetail && this?.props?.userDetail?.role.length>0 ? (
              <div className="cursor-pointer" onClick={this.props.toggleSidebar}>
                <AlignRight />
              </div>
            ):(
              // <div className="cursor-pointer" onClick={this.props.toggleSidebar}>
              //   <AlignRight />
              // </div>
              ""
            )
          }
        </div >
      </div>
    );
  }
}

export default Navbar;
